import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getNortonProductsAttributes,
  getNortonProductsPrice,
  getProducts,
} from '../../store/reducers';
import {
  GetNortonProductPrice,
  GetNortonProductsAttributes,
} from '../store/actions/norton.actions';
import { OnDestroyHookDirective } from '../../shared/hooks';
import { combineLatest } from 'rxjs';
import {
  CustomerService,
  LanguageService,
  TranslationService,
} from '@proximus/ng-common';
import { CustomerAccount } from '@proximus/common-business-logic';
import { isRes, Product } from '@dch/products-business-logic';
import * as ProductsActions from '../../store/actions/products.actions';
import { AlwaysProtectedCheckService } from "../../services/always-protected-check.service";
import { NortonProductCheckService } from "../../services/norton-product-check.service";
@Component({
  selector: 'mprd-norton-subscription',
  templateUrl: './norton-subscription.component.html',
  styleUrls: ['./norton-subscription.component.css'],
})
export class NortonSubscriptionComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  norton1Name: string;
  norton5Name: string;
  price: number;
  frequency: string;
  norton1MpcUuid: string;
  norton1Count: number;
  norton1LicenseCount: number;
  norton5MpcUuid: string;
  norton5Count: number;
  norton5LicenseCount: number;
  nortonProdValue;
  isAlwaysProtectedValue = false;
  constructor(
    private store: Store<ApplicationState>,
    private customerService: CustomerService,
    private languageService: LanguageService,
    private translationService: TranslationService,
    private isAlwaysProtectedService: AlwaysProtectedCheckService,
    private nortonProdCheck: NortonProductCheckService
  ) {
    super();
  }

  ngOnInit() {
    this.setNortonLicenseCount();
    this.setNortonMpcUuids();
    this.addSubscription(
      this.store.select(getNortonProductsAttributes).subscribe((value) => {
        if (value) {
          if (value[this.norton1MpcUuid]) {
            this.norton1Name =
              value[this.norton1MpcUuid].nameCms[
                this.languageService.getSelectedLanguage()
              ];
          }
          if (value[this.norton5MpcUuid]) {
            this.norton5Name =
              value[this.norton5MpcUuid].nameCms[
                this.languageService.getSelectedLanguage()
              ];
          }
        }
      }),
    );


    this.addSubscription(
      combineLatest([
        this.store.select(getNortonProductsPrice),
        this.customerService.getCustomerAccount(),
      ]).subscribe((res: [any, CustomerAccount]) => {
        const price = res[0];
        const customerAccount = res[1];
        const segment = customerAccount.getSelectedCustomer().subsegment;
        if (
          price &&
          price.calculated_prices &&
          price.calculated_prices.length > 0
        ) {
          this.frequency = price.calculated_prices[0].charge_frequency;
          this.price = isRes(segment)
            ? price.calculated_prices[0].standalone_price_vat
            : price.calculated_prices[0].standalone_price_no_vat;
        }
      }),
    );
    this.addSubscription(
      this.store.select(getProducts).subscribe((products) => {
        if (products) {
          this.norton1Count = this.countProduct(products, this.norton1MpcUuid);
          this.norton5Count = this.countProduct(products, this.norton5MpcUuid);
          this.isAlwaysProtectedService.norton5SubscriptionCount(this.norton5Count)
        }
      }),

    );

    this.store.dispatch(new ProductsActions.GetProducts());
    this.store.dispatch(
      new GetNortonProductsAttributes({
        mpcUuids: [this.norton1MpcUuid, this.norton5MpcUuid],
      }),
    );
    this.store.dispatch(
      new GetNortonProductPrice({ mpcUuid: this.norton1MpcUuid }),
    );

    this.isAlwaysProtectedService.currentAlwaysProtected.subscribe((isAlwaysProtected) => {
      this.isAlwaysProtectedValue = isAlwaysProtected
    });
    this.nortonProdValue = this.nortonProdCheck.nortonProdValue;
  }

  private countProduct(products: Array<Product>, groupMpcUuid: string) {
    console.log(products.filter((product) => groupMpcUuid === product.groupMpcUuid)
      .length)
    return products.filter((product) => groupMpcUuid === product.groupMpcUuid)
      .length;
  }

  public getDescriptionLabel(count: number) {
    return this.translationService
      .getTranslatedValueFor('norton.subscription.desc')
      .replace(/\{0\}/g, isNaN(count) ? 0 : count);
  }

  public setNortonLicenseCount() {
    this.norton1LicenseCount = Number(
      this.translationService.getTranslatedValueFor(
        'norton.subscription.norton1LicenseCount',
      ),
    );
    this.norton5LicenseCount = Number(
      this.translationService.getTranslatedValueFor(
        'norton.subscription.norton5LicenseCount',
      ),
    );
  }

  public setNortonMpcUuids() {
    this.norton1MpcUuid = this.translationService.getTranslatedValueFor(
      'norton.subscription.norton1MpcUuid',
    );
    this.norton5MpcUuid = this.translationService.getTranslatedValueFor(
      'norton.subscription.norton5MpcUuid',
    );
  }

  public openLink(key: string) {
    const link = this.translationService.getTranslatedValueFor(key);
    if (link) {
      window.open(link, '_blank');
    }
  }
}
